import * as THREE from "three";
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertexParticles.glsl";
import * as dat from "dat.gui";
import mask from '../mask.jpg'

import t from '../impostor.png'
import t1 from '../2.png'


import gsap from "gsap";
import { LuminanceFormat } from "three";
// let OrbitControls = require("three-orbit-controls")(THREE);

function rand(a,b){
  return a + (b-a)*Math.random();
}

export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0x000000, 1); 
    this.renderer.physicallyCorrectLights = true;
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.container.appendChild(this.renderer.domElement);
    this.delta = 0;
    this.speed = 0;

    this.camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.001,
      10000
    );

    this.textures = [
      new THREE.TextureLoader().load(t),
      new THREE.TextureLoader().load(t1),
    ]

    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, 1000);
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.time = 0;

    this.isPlaying = true;
    
    this.addObjects();
    this.resize();
    this.render();
    this.setupResize();
    this.settings();
    this.mouseEvents()
  }

  mouseEvents(){
    let that = this;
    that.testplane = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(2000,2000),
      new THREE.MeshBasicMaterial()
    )
    function onMouseMove( event ) {

      // calculate mouse position in normalized device coordinates
      // (-1 to +1) for both components

      that.mouse.x = -( event.clientX / window.innerWidth ) * 2 + 1;
      that.mouse.y =  ( event.clientY / window.innerHeight ) * 2 - 1;

      that.raycaster.setFromCamera( that.mouse, that.camera );

      // calculate objects intersecting the picking ray
      var intersects = that.raycaster.intersectObjects( [that.testplane] );
      that.mouse.x = intersects[0].point.x;
      that.mouse.y = intersects[0].point.y;

    }

    function onMouseDown(){
      gsap.to(that.material.uniforms.uPress,{
        duration: 1,
        value:1,
        ease: "elastic.out(1, 0.5)"
      })
    }
    function onMouseUp(){
      gsap.to(that.material.uniforms.uPress,{
        duration: 1,
        value:0,
        ease: "elastic.out(1, 0.5)"
      })
    }

    function onMouseWheel(e){
      // console.log(e.wheelDeltaY);
      // that.delta +=-e.wheelDeltaY/10000;
    }

    window.addEventListener( 'mousemove', onMouseMove, false );
    window.addEventListener( 'mousedown', onMouseDown, false );
    window.addEventListener( 'mouseup', onMouseUp, false );
    window.addEventListener( 'mousewheel', onMouseWheel, false );
  }

  settings() {
    let that = this;
    this.settings = {
      progress: 0,
      up: 0,
      transition: 0,
      next: ()=>{
        gsap.to(this.settings,{
          duration:1,
          progress: 1,
          ease: "power4.out"
        })
        gsap.to(this,{
          duration:0.5,
          speed: 1
        })
        gsap.to(this,{
          duration:2,
          delta: this.delta+1,
          delay: 0.5
        })

        gsap.to(this.settings,{
          duration:1,
          progress: 0,
          delay:2
        })
        // gsap.to(this,{
        //   duration:0.5,
        //   speed: 1,
        //   delay: 0.5
        // })
      }
    };
    this.gui = new dat.GUI();
    // this.gui.add(this.settings, "progress", 0, 1, 0.01);
    // this.gui.add(this.settings, "transition", 0, 1, 0.01);
    // this.gui.add(this.settings, "up", 0, 1, 0.01);
    this.gui.add(this.settings, "next");
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    

    // image cover
    this.imageAspect = 853/1280;
    let a1; let a2;
    if(this.height/this.width>this.imageAspect) {
      a1 = (this.width/this.height) * this.imageAspect ;
      a2 = 1;
    } else{
      a1 = 1;
      a2 = (this.height/this.width) / this.imageAspect;
    }

    this.material.uniforms.resolution.value.x = this.width;
    this.material.uniforms.resolution.value.y = this.height;
    this.material.uniforms.resolution.value.z = a1;
    this.material.uniforms.resolution.value.w = a2;


    // optional - cover with quad
    // const dist  = this.camera.position.z;
    // const height = 1;
    // this.camera.fov = 2*(180/Math.PI)*Math.atan(height/(2*dist));

    // // if(w/h>1) {
    // if(this.width/this.height>1){
    //   this.plane.scale.x = this.camera.aspect;
    //   // this.plane.scale.y = this.camera.aspect;
    // } else{
    //   this.plane.scale.y = 1/this.camera.aspect;
    // }

    this.camera.updateProjectionMatrix();


  }

  addObjects() {
    let that = this;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable"
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { type: "f", value: 0 },
        uHide: { type: "f", value: 0 },
        uDelta: { type: "f", value: 0 },
        uMouse: { type: "v2", value: null },
        uSpeed: { type: "f", value: null },
        uPress: { type: "f", value: 0 },
        uTransition: { type: "f", value: 0 },
        u_progress: { type: "f", value: 0 },
        u_map: { type: "t", value: new THREE.TextureLoader().load(t) },
        u_map1: { type: "t", value: new THREE.TextureLoader().load(t1) },
        u_mask: { type: "t", value: new THREE.TextureLoader().load(mask) },
        resolution: { type: "v4", value: new THREE.Vector4() },
        uvRate1: {
          value: new THREE.Vector2(1, 1)
        }
      },
      // wireframe: true,
      vertexShader: vertex,
      fragmentShader: fragment,
      transparent: true,
      depthTest: false,
      depthWrite: false,
    });
    this.number = 262144;
    this.geo = new THREE.BufferGeometry();

    this._aPosition = new THREE.BufferAttribute(new Float32Array(3 * this.number),3),
    this._aHidePosition = new THREE.BufferAttribute(new Float32Array(3 * this.number),3),
    this._aCoordinates = new THREE.BufferAttribute(new Float32Array(2 * this.number),2),
    this._aSelect = new THREE.BufferAttribute(new Float32Array(1 * this.number),1),
    this._selectOffsetSpeeds = new Float32Array(this.number),
    this._aDirection = new THREE.BufferAttribute(new Float32Array(this.number),1),
    this._aSpeed = new THREE.BufferAttribute(new Float32Array(this.number),1),
    this._aRadius = new THREE.BufferAttribute(new Float32Array(this.number),1),
    this._aOffset = new THREE.BufferAttribute(new Float32Array(this.number),1),
    this._aPress = new THREE.BufferAttribute(new Float32Array(this.number),1);


    let e = 0;
    for (let t = 0; t < 512; t += 1) {
        const i = t - 256;
        for (let n = 0; n < 512; n += 1) {
            const r = 512 - n - 256;
            this._aPosition.setXYZ(e, 1.3 * r, 1.3 * i, 0);

            this._aHidePosition.setXYZ(e, 
              rand(-2e3, 2e3), 
              rand(-2e3, 2e3), 
              rand(1150, 1200)
            );

            this._aCoordinates.setXY(e, n, t);
            this._aSelect.setX(e, 1);
            this._selectOffsetSpeeds[e] = rand(.055, .1);
            this._aDirection.setX(e,rand(0, 1) <= .5 ? -1 : 1),
            this._aSpeed.setX(e, rand(.3, 1));
            this._aRadius.setX(e, rand(0, 50));
            this._aOffset.setX(e, rand(-1e3, 1e3));
            this._aPress.setX(e, rand(.6, 1));
            e++;
        }
    }
    this.geo.setAttribute("position", this._aPosition),
    this.geo.setAttribute("a_hidePosition", this._aHidePosition),
    this.geo.setAttribute("a_coordinates", this._aCoordinates),
    this.geo.setAttribute("a_select", this._aSelect),
    this.geo.setAttribute("a_direction", this._aDirection),
    this.geo.setAttribute("a_speed", this._aSpeed),
    this.geo.setAttribute("a_radius", this._aRadius),
    this.geo.setAttribute("a_offset", this._aOffset),
    this.geo.setAttribute("a_press", this._aPress)


    this.geometry = new THREE.PlaneGeometry(1, 1, 10, 10);

    this.plane = new THREE.Points(this.geo, this.material);
    this.scene.add(this.plane);
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if(!this.isPlaying){
      this.render()
      this.isPlaying = true;
    }
  }

  render() {
    if (!this.isPlaying) return;
    this.time += 0.05;
    // this.delta +=this.speed;
    // console.log(this.mouse);

    // this.camera.rotation.x += .0011 * (.01 * this.mouse.y - this.camera.rotation.x),
    // this.camera.rotation.y += .0011 * (-.01 * this.mouse.x - this.camera.rotation.y);

    let next = Math.floor(this.delta)%2;
    let prev = (Math.floor(this.delta)%2 +1)%2
    this.material.uniforms.u_map.value = this.textures[next];
    this.material.uniforms.u_map1.value = this.textures[prev];
    this.material.uniforms.time.value = this.time;
    this.material.uniforms.uSpeed.value += this.speed;
    console.log(this.material.uniforms.uSpeed.value);
    this.material.uniforms.uHide.value = this.settings.progress;
    this.material.uniforms.uTransition.value = this.settings.transition;
    this.material.uniforms.uDelta.value = this.delta;
    this.material.uniforms.uMouse.value = this.mouse;
    this.material.uniforms.u_progress.value = this.settings.up;
    requestAnimationFrame(this.render.bind(this));
    this.renderer.render(this.scene, this.camera);
  }
}

new Sketch({
  dom: document.getElementById("container")
});
